
export enum ComplianceRequirementType {
    DOCUMENT = 'document'
}